// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3oMK0","loaderOuter":"PageOverlayLoader_loaderOuter__10yR5"};